export var Phase;
(function (Phase) {
    Phase["PassivesAndReactions"] = "Passives & Reactions";
    Phase["Deployment"] = "Deployment Phase";
    Phase["StartOfBattleRound"] = "Start of Battle Round";
    Phase["StartOfTurn"] = "Start of Turn";
    Phase["Hero"] = "Hero Phase";
    Phase["Movement"] = "Movement Phase";
    Phase["Shooting"] = "Shooting Phase";
    Phase["Charge"] = "Charge Phase";
    Phase["Combat"] = "Combat Phase";
    Phase["EndOfTurn"] = "End of Turn";
    Phase["Unknown"] = "Unknown Phase";
})(Phase || (Phase = {}));
